module.exports = __webpack_public_path__ + "static/media/Logo-Dr-Consulta-Branco.f962f442.svg";